import * as React from 'react';
import { useGetTreeMarkingQuery } from "../../../apis/TreeMarking.api";
import { PrimaryTreeMarking, TreeMarking } from "../../../types/models/TreeMarking";
import TimberTypeName from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: TreeMarking;
};

export const TreeMarkingNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><TimberTypeName id={ data?.timberTypeId }/>
                    {data?.volume && <> | </> }{ data?.volume }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const TreeMarkingName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetTreeMarkingQuery(PrimaryTreeMarking.fromId(id))
    return (<TreeMarkingNameDisplay data={data}/>)
}

export default TreeMarkingName;
